import { ActivatedRouteSnapshot, CanActivateFn, CanMatchFn, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { LocalizedRouteService, ProfileState } from '@lexplus-shared-lib';
import { AUTH_ROUTE_IDS, LOCALIZED_AUTH_ROUTES } from '../auth-route-const';

@Service()
export class WorkIsLoggedInService {
  private readonly store = inject(Store);
  private readonly router = inject(Router);
  private readonly localizedRouteService = inject(LocalizedRouteService);

  public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const isLoggedIn = this.store.selectSnapshot(ProfileState.isLoggedIn);

    if (!isLoggedIn) {
      const loginRoute =
        '/' +
        this.localizedRouteService.getLocalizedRoute(
          LOCALIZED_AUTH_ROUTES[AUTH_ROUTE_IDS.ROOT],
          LOCALIZED_AUTH_ROUTES[AUTH_ROUTE_IDS.LOGIN],
        );
      void this.router.navigate([loginRoute], { queryParams: { returnUrl: state.url } });
      return false;
    }

    return true;
  }
}

export const IsLoggedInGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return <boolean>inject(WorkIsLoggedInService).canActivate(next, state);
};

/** Matches a route only for a signed-in user, so the router falls through to the next candidate otherwise. */
export const IsLoggedInMatchGuard: CanMatchFn = (): boolean => inject(Store).selectSnapshot(ProfileState.isLoggedIn);
